import Rails from '@rails/ujs'

export function updateInboxEntries(inboxId, attributes, successCallback) {
  const url = `/search/inboxes/${inboxId}`

  Rails.ajax({
    type: 'put',
    dataType: 'script',
    url: url,
    data: $.param({ inbox_attributes: attributes }),
    success: () => successCallback()
  })
}
